export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;
export const MAPBOX_MIN_ZOOM = 15;export const APP_VERSION = "0.0.14";
